import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TeminalSecurityIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M12 22C9.68333 21.4167 7.77083 20.0875 6.2625 18.0125C4.75417 15.9375 4 13.6333 4 11.1V5L12 2L20 5V11.1C20 13.6333 19.2458 15.9375 17.7375 18.0125C16.2292 20.0875 14.3167 21.4167 12 22ZM12 19.9C13.6167 19.4 14.9667 18.4125 16.05 16.9375C17.1333 15.4625 17.7667 13.8167 17.95 12H12V4.125L6 6.375V11.55C6 11.6667 6.01667 11.8167 6.05 12H12V19.9Z'
                fill='currentColor'
            />
        </>
    ),
})

TeminalSecurityIcon.displayName = 'TeminalSecurityIcon'
